import React from 'react';
import { OutlookColor, OutlookRegular } from '@fluentui/react-brand-icons';
import { isCapabilityEnabled } from 'owa-capabilities';
import { headerAppIconCapability } from 'owa-capabilities-definitions/lib/headerAppIconCapability';
import { observer } from 'owa-mobx-react';
import { getCurrentThemeId, getIsCurrentThemeModern } from 'owa-theme';
import { headerIconContainer, headerIcon } from '../OwaHeader.scss';

const defaultExport: React.FunctionComponent = observer(function OwaHeaderAppIcon() {
    if (!isCapabilityEnabled(headerAppIconCapability)) {
        return null;
    }

    const themeId = getCurrentThemeId();
    const isModernTheme = getIsCurrentThemeModern(themeId);

    return (
        <div className={headerIconContainer}>
            {isModernTheme ? (
                <OutlookColor className={headerIcon} />
            ) : (
                <OutlookRegular className={headerIcon} />
            )}
        </div>
    );
}, 'OwaHeaderAppIcon');

export default defaultExport;
